<template>
  <div v-if="users.length > 0">
     <div class="row py-2">
        <div v-for="(user, index) in users" :key="index" class="col-2 p-1"> 
          <span class="badge rounded-pill bg-danger w-100 py-2" style="cursor:pointer;" @click="addUserAsPresenter(user.text)">{{ user.text }} <i class="fas fa-user-plus"></i></span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    users: {
      type: Array,
      default: null,
    },
  },
  methods: {
    addUserAsPresenter(text) {
      this.$emit('show-add-user-as-presenter-modal', {
        title: 'Add User As Presenter: ' + text,
        userForm: { first_name: text.split(' ')[0], last_name: text.split(' ')[1] || '' },
        invitationName: text,
        showInviteModal: true,
        inInviteMode: true,
        submitText: 'Submit',
      });
    }
  },
};
</script>